var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28978 14.6984C12.9914 14.5362 15.8606 11.4039 15.6984 7.70232C15.5362 4.00072 12.404 1.13147 8.70235 1.29369C5.00074 1.4559 2.1315 4.58815 2.29371 8.28975C2.45593 11.9914 5.58817 14.8606 9.28978 14.6984Z",
    stroke: "#888888",
    strokeWidth: 1.09336,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5907 13.3478L12.8728 13.983C12.8728 13.983 16.8074 20.6091 18.2527 19.4352C19.7018 18.2582 13.5907 13.3478 13.5907 13.3478Z",
    fill: "#888888"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.00685,
    cy: 5.24342,
    r: 2.12208,
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82031 10.7993C4.82031 8.56804 6.62907 6.75928 8.86029 6.75928H9.02612C11.2573 6.75928 13.0661 8.56804 13.0661 10.7993V11.731H4.82031V10.7993Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditLog);
export default __webpack_public_path__ + "static/media/auditLog.8ddc62d72e77dd2d9239b62d7c1fe3f9.svg";
export { ForwardRef as ReactComponent };